import {Metric_Get as defaultMetrics} from './backend'

const getDefaultMetrics = async () => {
  let {data} = await defaultMetrics()
  return data
}

export default {
  getDefaultMetrics,
}
